import { customQuery } from 'config/reactQuery/reactQuery';
import { APIResponse } from '@alluradirect/react';

export const getTurnstileEndpoint = () => { return "/RESTAUTH/user/turnstile"; };

export const verifyTurnstileToken = async (captchaToken: string, widget: string) => {
  return await customQuery<APIResponse<{ SUCCESS: boolean }>>(getTurnstileEndpoint(), {
    method: "POST",
    values: { cfturnstileresponse: captchaToken, widget },
    shouldAcceptFalseSuccess: true,
  });
};
